export const MOOV_COLOR_WHITE = '#FFFFFF';
export const MOOV_COLOR_WHITE_TRANSPARENT = '#FFFFFF00';
export const MOOV_COLOR_LIGHTBLUE_TRANSPARENT = '#AADBFFDB';
export const MOOV_COLOR_LIGHTBLUE = '#27A4FFB7';
export const MOOV_COLOR_BLUE = '#005798';
export const MOOV_COLOR_MAGENTA = '#932478E5';
export const MOOV_COLOR_PURPLE = '#93144E';
